const BANNER_IMAGE_SIZE = {
  width: 900,
  height: 250,
};

export { BANNER_IMAGE_SIZE };
